import { render, staticRenderFns } from "./InsertPaymentDialog.vue?vue&type=template&id=12d9bb90&"
import script from "./InsertPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./InsertPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports